module.exports = "/static/assets/45bfd46de0357ec381d51fc0f88011ea.png";